import * as core from '../../../../../../../core'
import * as changeImpactFunctionalArea from '../change-impact-functional-area'

export const RESOURCE = {
  payload: {
    description: 'Data Migration',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactFunctionalArea.RESOURCE.payload.partialId,
    }),
    id: 'Data Migration',
    name: 'Data Migration',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
